import clone from 'clone'
import { fetch } from '@/services'

const getValue = function (item, path) {
  const keys = path.split('.')
  let currentState = item
  if (currentState.meta[keys[0]]) currentState = currentState.meta
  return keys.reduce((current, value) => {
    return typeof current && current[value] !== undefined ? current[value] : undefined
  }, currentState)
}
const setValue = function (item, path, value) {
  const keys = path.split('.')
  let currentState = item
  if (currentState.meta[keys[0]]) currentState = currentState.meta
  keys.forEach((key, i) => {
    if (i === keys.length - 1) {
      currentState[key] = value
    } else if (!currentState[key]) {
      if (!isNaN(parseInt(keys[i + 1]))) {
        currentState[key] = {}
      } else {
        currentState[key] = []
      }
    }
    currentState = currentState[key]
  })
  return item
}

export const get = async (type, global = false) => {
  const path = `/data/${type}${!global ? '.' + window.lang : ''}.json`
  const url = new URL(path, window.location.origin).toString()
  
  const response = await fetch(url, { credentials: 'same-origin' })
  const json = await response.json()
  return response.ok ? json : []
}

const populateFromParent = (parents, childs, key) => {
  if (Array.isArray(parents)) {
    parents = parents.map(parent => {
      if (parent.meta[key]) {
        if (Array.isArray(parent.meta[key])) {
          parent.meta[key] = parent.meta[key].map(childId => {
            return childs.filter(child => child.id === childId)[0]
          })
        } else {
          parent.meta[key] = childs.filter(child => child.id === parent.meta[key])[0]
        }
      }
      return parent
    })
  } else {
    if (parents.meta[key]) {
      if (Array.isArray(parents.meta[key])) {
        parents.meta[key] = parents.meta[key].map(childId => {
          return childs.filter(child => child.id === childId)[0]
        })
      } else {
        parents.meta[key] = childs.filter(child => child.id === parents.meta[key])[0]
      }
    }
  }

  return parents
}

const populateFromChild = (parents, childs, childKey, parentKey) => {
  parents = parents.map(parent => {
    const childsFiltered = childs.filter(child => child.meta[childKey] === parent.id)
    parent.meta[parentKey] = childsFiltered
    return parent
  })

  return parents
}

export const populate = (parents, childs, key, reverse = false) => {
  let parentsClone = clone(parents)
  let childsClone = clone(childs)

  if (reverse === false) {
    parentsClone = populateFromParent(parentsClone, childsClone, key)
  } else {
    parentsClone = populateFromChild(parentsClone, childsClone, key, reverse)
  }

  return parentsClone
}

export const sort = (items, orderby, order) => {
  if (!items) return []
  let itemsClone = clone(items)
  itemsClone.sort((a, b) => {
    let aValue = getValue(a, orderby)
    let bValue = getValue(b, orderby)

    if (aValue === undefined || bValue === undefined) return 0

    if (parseInt(aValue).toString() === aValue && parseInt(bValue).toString() === bValue) {
      aValue = parseInt(aValue)
      bValue = parseInt(bValue)
    }
    if (order === 'desc') {
      if (aValue > bValue) return -1
      if (aValue < bValue) return 1
      return 0
    } else {
      if (aValue < bValue) return -1
      if (aValue > bValue) return 1
      return 0
    }
  })

  return itemsClone
}

export const filter = (items, key, value, compare = '=') => {
  let itemsClone = clone(items)
  itemsClone = itemsClone.filter(item => {
    const field = getValue(item, key)
    if (field !== undefined) {
      switch (compare) {
        case 'regex':
          return field.match(value)
        case '<':
          return field < value
        case '<=':
          return field <= value
        case '>':
          return field > value
        case '>=':
          return field >= value
        default:
          if (Array.isArray(field)) {
            return field.includes(value)
          } else {
            return field === value
          }
      }
    }
    return false
  })

  return itemsClone
}

export const limit = (items, limit, from = 0) => {
  let itemsClone = clone(items)

  itemsClone = itemsClone.slice(from, from + limit)

  return itemsClone
}

export const paginate = (items, perPage = 10) => {
  let itemsClone = clone(items)

  if (Array.isArray(itemsClone)) {
    const pagination = {}
    const pages = Math.ceil(itemsClone.length / perPage)
    for (var i = 1; i <= pages; i++) {
      pagination[i] = limit(items, perPage, (i - 1) * perPage)
    }
    return pagination
  }

  return false
}

export default {
  get,
  populate,
  sort,
  filter,
  limit,
  paginate
}
